import Marquee from "react-fast-marquee";
import { SPONSORS } from "../lib/site";

export const SponsorMarquee = ({ testid = "sponsor-marquee" }) => {
  if (!SPONSORS.length) return null;
  const copies = Math.max(2, Math.ceil(6 / SPONSORS.length));

  return (
    <div className="relative z-10 bg-white border-y border-black/5 py-6" data-testid={testid}>
      <p className="mb-4 text-center text-[11px] uppercase tracking-[0.3em] text-ink-soft">
        Proudly sponsored by
      </p>
      <Marquee speed={35} gradient={false} pauseOnHover>
        {Array.from({ length: copies }).flatMap((_, copy) =>
          SPONSORS.map((s, i) => (
            <a
              key={`${copy}-${s.name}`}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Visit ${s.name}`}
              className="mx-10 sm:mx-14 block transition-transform duration-300 hover:scale-105"
              data-testid={`sponsor-logo-${copy}-${i}`}
            >
              <img src={s.logo} alt={s.name} className="h-11 sm:h-14 w-auto object-contain" />
            </a>
          ))
        )}
      </Marquee>
    </div>
  );
};
